import type { FC } from 'react';
import { useState } from 'react';
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Collapse,
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { numberToMillons } from 'src/utils/functions';

const KpiTuberiaFuvex: FC<{ item: any }> = ({ item }) => {
  const [open, setOpen] = useState(item.detail?.open);
  const detailId = `detail-${item.id}`;

  return (
    <>
      <TableRow key={item.id}>
        <TableCell>
          {item.fuvex}
          {item.detail && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>
        <TableCell align="right">{numberToMillons(item.facturacion)}</TableCell>
        <TableCell align="right" width={100}>
          {item.cantidad}
        </TableCell>
      </TableRow>
      {item.detail && (
        <>
          <TableRow key={detailId}>
            <TableCell
              colSpan={3}
              style={{ display: open ? 'table-cell' : 'none', padding: 0 }}
            >
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Table size="small" style={{ background: 'white' }}>
                  <TableBody>
                    {item.detail?.data?.map((detail) => (
                      <TableRow key={detail.id}>
                        <TableCell>{detail.name}</TableCell>
                        <TableCell align="right">
                          {numberToMillons(detail.facturacion)}
                        </TableCell>
                        <TableCell align="right" width={100}>
                          {detail.cantidad}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Collapse>
            </TableCell>
          </TableRow>
        </>
      )}
    </>
  );
};

export default KpiTuberiaFuvex;
